import cn from 'classnames';
import { Element, List } from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { IRankingTeam } from '@zmedia/bm-soccer-ui/interface';
import { Team } from '@zmedia/bm-soccer-ui/modules/match';
import styles from '../style.module.scss';
import { twMerge } from 'tailwind-merge';

function TableRow({
    item,
    color = 'initial',
    home,
    away,
    hasMatchRecent = false,
    teamIdSelect,
}: {
    item: IRankingTeam;
    color?: string;
    home?: any;
    away?: any;
    hasMatchRecent?: boolean;
    teamIdSelect?: number;
}) {
    const className = cn(
        'td',
        'text-[1.4rem] leading-normal text-[var(--black-80)]',
        'text-center',
        'w-[6rem]'
    );

    return (
        <Element
            className={styles['tr']}
            key={item.position}
            style={Object.assign(
                {},
                {
                    '--group-color': color,
                } as React.CSSProperties,
                home?.team?.id === item.team.id ||
                    away?.team?.id === item.team.id ||
                    teamIdSelect === item.team.id
                    ? { backgroundColor: '#f7f7f7' }
                    : {}
            )}
        >
            <Element renderAs="span" className={className}>
                {item.position}
            </Element>
            <Element renderAs="span" className={className}>
                <Team team={item.team} isLink={true} />
            </Element>
            <Element renderAs="span" className={className}>
                {item.mp}
            </Element>
            <Element renderAs="span" className={className}>
                {item.w}
            </Element>
            <Element renderAs="span" className={className}>
                {item.d}
            </Element>
            <Element renderAs="span" className={className}>
                {item.l}
            </Element>
            <Element renderAs="span" className={className}>
                {item.gf} - {item.ga}
            </Element>
            <Element renderAs="span" className={className}>
                {item.gd}
            </Element>
            <Element renderAs="span" className={className}>
                <Element renderAs="b">{item.point}</Element>
            </Element>
            <Element
                renderAs="span"
                className={twMerge(className, 'w-[150px] mr-[24px]')}
                style={Object.assign(
                    {},
                    hasMatchRecent ? {} : { display: 'none' }
                )}
            >
                {item?.mr ? (
                    <List className={styles['list-result']}>
                        {item?.mr?.map((item, index) => {
                            return (
                                <List.Item
                                    key={index}
                                    className={cn(styles['result'], {
                                        [styles['is-win']]: item === 'w',
                                        [styles['is-draw']]: item === 'd',
                                        [styles['is-lose']]: item === 'l',
                                    })}
                                >
                                    <></>
                                </List.Item>
                            );
                        })}
                    </List>
                ) : (
                    <Element>Chưa có thông tin</Element>
                )}
            </Element>

            {/* <Element renderAs="span" className={styles['td']}>
                <Image
                    src={
                        'https://znews-photo.zingcdn.me/Uploaded/yuiikx/team/3731.png'
                    }
                />
            </Element> */}
        </Element>
    );
}

export default memo(TableRow);
